import React from "react";
import { F_Fammily, Font } from "../../util/config-fonts";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_common } from "../../classes/dto-common";
import { FORMAT_DECIMAL_VALUE } from "../../functions/funtion";
import { Colors } from "../../util/colors";

export default class RecommendedItems extends React.Component {
  render() {
    return (
      <div className="itemListLayout fadeInUp animated" style={{marginBottom: '60px'}}>
        {this.props.data.map((e, i) => {
          return (
            <div
              className="itemListLayout fadeInUp animated"
              data-wow-duration="300ms"
              data-wow-delay="0ms"
              key={e.PI + "Reco" + i}
            >
              <div
                className="itemListRow"
                style={{ gridTemplateColumns: "auto 50px 10px" }}
              >
                <div
                  className="itemListRowText"
                  onClick={() => {
                    this.props.NavigateToProductPage(e);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontFamily: F_Fammily.Medium,
                      fontSize: "13px",
                      marginBottom: 0,
                    }}
                  >
                    {e.D}
                  </p>
                  {e.G === "" || e.G === "N/A" ? null : (
                    <p
                      style={{
                        marginTop: "5px",
                        fontStyle: "italic",
                        fontSize: Font.Description,
                        margin: 0,
                      }}
                    >
                      {e.G}
                    </p>
                  )}
                  {e.UD > 0 ? (
                    <div style={{ display: "flex" }}>
                      <p
                        style={{
                          paddingTop: 0,
                          marginTop: "4px",
                          marginBottom: "4px",
                          fontSize: Font.Amount,
                          color: "red",
                          alignSelf: "stretch",
                          textDecorationLine: "line-through",
                          textDecorationStyle: "solid",
                          marginRight: 5,
                        }}
                      >
                        {dto_StartupPageLoadInfo.Currency}
                        {"  "}
                        {FORMAT_DECIMAL_VALUE(2, parseFloat(e.P), 2)}
                      </p>
                      <p
                        style={{
                          paddingTop: 0,
                          color: Colors.ThemeBGcolor,
                          marginTop: "4px",
                          marginBottom: "4px",
                          fontSize: Font.Amount,
                        }}
                      >
                        {dto_StartupPageLoadInfo.Currency}
                        {"  "}
                        {FORMAT_DECIMAL_VALUE(
                          2,
                          parseFloat(e.P) - parseFloat(e.UD),
                          2
                        )}
                      </p>
                    </div>
                  ) : (
                    <p
                      style={{
                        fontSize: Font.Amount,
                        margin: 0,
                        color: Colors.ThemeBGcolor,
                      }}
                    >
                      {dto_StartupPageLoadInfo.Currency}{" "}
                      {parseFloat(e.P)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                    </p>
                  )}
                </div>
                <div
                  className="itemListRowText"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    this.props.NavigateToProductPage(e);
                  }}
                >
                  <img
                    src={e.IU}
                    onError={(e) => {
                      e.currentTarget.src = dto_common.DefaultImageUrl;
                    }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
